// src/features/dashboard/services/Employee/employeeIdleTime.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  EmployeeIdleTimeRequest,
  EmployeeIdleKpiResponse,
  IdleMinuteByHourResponse,
  WTDIdleTrendResponse,
  IdleVsTeamResponse,
  IdleDailyDetailResponse,
} from '../../types/Employee/employeeIdleTime.types';

export const getEmployeeIdleKPIs = async (
  request: EmployeeIdleTimeRequest
): Promise<EmployeeIdleKpiResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_IDLE_KPI,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    }
  );

  return data;
};

export const getIdleMinutesChart = async (
  request: EmployeeIdleTimeRequest
): Promise<IdleMinuteByHourResponse[]> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_IDLE_HOURLY,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    }
  );

  return data;
};

export const getIdleWTDTrend = async (
  request: EmployeeIdleTimeRequest
): Promise<WTDIdleTrendResponse[]> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_IDLE_WTD_TREND,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    }
  );

  return data;
};

export const getIdleTeamComparison = async (
  request: EmployeeIdleTimeRequest
): Promise<IdleVsTeamResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_IDLE_ME_VS_TEAM,
    {
      employeeCode: request.employeeCode,
      currentDate: request.date,
    }
  );

  return data;
};

export const getIdleDailyDetails = async (
  request: EmployeeIdleTimeRequest
): Promise<IdleDailyDetailResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_IDLE_DAILY,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    }
  );

  return data;
};